import { useCallback, useEffect, useMemo, useState } from "react"

export default function hookPivotTableStoreFactory(collectionsURL) {
  return ({ fetch, siteSelected, loading }) => {
    const [attachedToSite, setAttachedToSiteSite] = useState(true)
    const [data, setData] = useState([])
    const [error, setError] = useState(null)

    const fetchCollections = useCallback(async payload => {
      const { key, id } = siteSelected
      const data = await fetch({
        method: 'post',
        url: `pivot/${collectionsURL}`,
        data: { ...payload, [key]: id },
      })
      setData(data)
    }, [fetch, siteSelected])

    return useMemo(() => ({
      attachedToSite, data, error, loading, fetchCollections,

      useLoad: (params, attachedToSite = true) => {
        useEffect(() => {
          const { startDate, endDate, metrics, sortby, groupby } = params
          if (startDate && endDate && metrics?.length && sortby?.length && groupby?.length ) {
            setError(null)
            fetchCollections(params).catch(error => {
              setData(null)
              setError(error)
            })
          }
        }, [params])

        useEffect(() => {
          setAttachedToSiteSite(attachedToSite)
        }, [attachedToSite])

        return useCallback(() => fetchCollections(params), [params])
      },
    }), [attachedToSite, data, error, loading, fetchCollections])
  }
}
